import { useTheme } from '../hooks/useTheme.tsx';
import { useT } from '../i18n.ts';

interface ThemeToggleProps {
  showLabel?: boolean;
}

export function ThemeToggle({ showLabel = false }: ThemeToggleProps) {
  const t = useT();
  const { theme, toggleTheme } = useTheme();
  const isDark = theme === 'graphite';
  const switchAria = isDark ? t('theme-toggle.switch-to-light') : t('theme-toggle.switch-to-dark');

  const button = (
    <button
      type="button"
      role="switch"
      aria-checked={isDark}
      className={`theme-switch${isDark ? ' is-dark' : ''}`}
      onClick={toggleTheme}
      aria-label={switchAria}
      title={switchAria}
    >
      <span className="theme-switch-track" aria-hidden="true">
        <svg className="theme-switch-icon sun" viewBox="0 0 24 24" width="14" height="14">
          <circle cx="12" cy="12" r="4" fill="currentColor" />
          <g stroke="currentColor" strokeWidth="2" strokeLinecap="round">
            <line x1="12" y1="2" x2="12" y2="5" />
            <line x1="12" y1="19" x2="12" y2="22" />
            <line x1="2" y1="12" x2="5" y2="12" />
            <line x1="19" y1="12" x2="22" y2="12" />
            <line x1="4.9" y1="4.9" x2="7" y2="7" />
            <line x1="17" y1="17" x2="19.1" y2="19.1" />
            <line x1="4.9" y1="19.1" x2="7" y2="17" />
            <line x1="17" y1="7" x2="19.1" y2="4.9" />
          </g>
        </svg>
        <svg className="theme-switch-icon moon" viewBox="0 0 24 24" width="14" height="14">
          <path
            d="M20 14.5A8 8 0 0 1 9.5 4a8 8 0 1 0 10.5 10.5z"
            fill="currentColor"
          />
        </svg>
        <span className="theme-switch-thumb" />
      </span>
    </button>
  );

  if (!showLabel) return button;

  return (
    <span className="theme-switch-group">
      {button}
      <span className="theme-switch-label">{isDark ? t('theme-toggle.label.dark') : t('theme-toggle.label.light')}</span>
    </span>
  );
}
